import React, { useCallback, useEffect, useState } from "react";
import "./css/dowload.css";
import film from "../assets/public/film.webp";
import music from "../assets/public/music.webp";
import dance from "../assets/public/dance.webp";
import mask from "../assets/public/mask.webp";
import trophy from "../assets/public/trophy.webp";
import quill from "../assets/public/quill.webp";
import DanceRules from "../assets/public/Dance Rules 2025.pdf";
import MusicRules from "../assets/public/Music Rules 2025.pdf";
import DramaRules from "../assets/public/Dramatics Rules 2025.pdf";
import SpeakingArtsRules from "../assets/public/Speaking Arts Rules 2025.pdf";
import DadaRules from "../assets/public/Design and Digital Arts Rules 2025.pdf";
import FineArtsRules from "../assets/public/Fine Arts Rules 2025.pdf";
import LiteraryArtsRules from "../assets/public/Literary Arts Rules 2025.pdf";
import LifestyleRules from "../assets/public/Fashion and Lifestyle Rules 2025.pdf";
import JournalismRules from "../assets/public/Journalism and Communication Rules 2025.pdf";

const downloadPdf = (title, fileLocation) => {
  const link = document.createElement("a");
  link.href = fileLocation;
  link.download = title + " Rules.pdf";
  link.click();
};

const Section = ({ title, fileLocation, onView }) => {
  const handleView = () => {
    if (!fileLocation) {
      alert(`${title} rules will be uploaded soon.`);
      return;
    }

    onView({ title, fileLocation });
  };

  const handleDownload = () => {
    if (!fileLocation) {
      alert(`${title} rules will be uploaded soon.`);
      return;
    }

    downloadPdf(title, fileLocation);
  };

  return (
    <div className="item">
      <h1>{title}</h1>
      <div className="btn-group">
        <button className="download-btn" onClick={handleView}>
          VIEW RULES
        </button>
        <button className="download-btn" onClick={handleDownload}>
          DOWNLOAD
        </button>
      </div>
    </div>
  );
};

const PdfViewer = ({ title, fileLocation, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div className="pdf-overlay" onClick={onClose}>
      <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-header">
          <h2>{title} Rules</h2>
          <div className="btn-group">
            <button
              className="download-btn"
              onClick={() => downloadPdf(title, fileLocation)}
            >
              DOWNLOAD
            </button>
            <button className="download-btn" onClick={onClose}>
              CLOSE
            </button>
          </div>
        </div>
        <iframe
          className="pdf-frame"
          src={fileLocation}
          title={`${title} Rules`}
        />
      </div>
    </div>
  );
};

const Dowload = () => {
  const [viewing, setViewing] = useState(null);
  const closeViewer = useCallback(() => setViewing(null), []);
  const sectionsData = [
    { title: "Dance", fileLocation: DanceRules},
    { title: "Music", fileLocation: MusicRules},
    { title: "Dramatics", fileLocation: DramaRules},
    { title: "Speaking Arts", fileLocation: SpeakingArtsRules},
    { title: "Design and Digital Arts", fileLocation: DadaRules},
    { title: "Fine Arts", fileLocation: FineArtsRules},
    { title: "Literary Arts", fileLocation: LiteraryArtsRules},
    { title: "Fashion and Lifestyle", fileLocation: LifestyleRules},
    { title: "Journalism and Communication", fileLocation: JournalismRules},
  ];

  return (
    <div className="text-with-images">
            <div className="images">
        <div className="image-container">
          <img src={dance} alt="dance" style={{ visibility: "hidden" }}/>
        </div>
        <div className="image-container">
          <img src={trophy} alt="trophy"/>
        </div>
        <div className="image-container">
          <img src={mask} alt="mask" style={{ visibility: "hidden" }}/>
        </div>
        <div className="image-container">
          <img src={film} alt="film"/>
        </div>
        <div className="image-container">
          <img src={quill} alt="quill" style={{ visibility: "hidden" }}/>
        </div>
        <div className="image-container">
          <img src={music} alt="music"/>
        </div>
      </div>

      <div className="text-content">
        <p>
          Mood Indigo is a cultural festival because of the 60+ unique
          Competitions that it conducts. Competitions are the foundation of Mood
          indigo and they cover the philosophy on which Mood Indigo is based.{" "}
        </p>
        <h6>LIVE YOUR PASSION: </h6>
        <p>
          Mood Indigo sets a stage for its participants to explore and pursue
          their interests going forward. The LYP or Live Your Passion provides
          incentives and opportunities to winners by collaborating with best
          names of the industry such as The Kings, Anupam Kher's Actor Prepares,
          NDTV Prime & many more.
        </p>
        <h6>CHAMPIONSHIP: </h6>
        <p>
          The top participants of each will be allotted a certain number of
          points, with the group competitions carrying a higher weightage. At
          the end of all the competitions, the college with the maximum number
          of points becomes the overall Champion!
        </p>

        <div className="container">
          {sectionsData.map((section, index) => (
            <Section
              key={index}
              title={section.title}
              fileLocation={section.fileLocation}
              onView={setViewing}
            />
          ))}
        </div>
      </div>
      {viewing && (
        <PdfViewer
          title={viewing.title}
          fileLocation={viewing.fileLocation}
          onClose={closeViewer}
        />
      )}
      <div className="images">
        <div className="image-container">
          <img src={dance} alt="dance" />
        </div>
        <div className="image-container">
          <img src={trophy} alt="trophy" style={{ visibility: "hidden" }} />
        </div>
        <div className="image-container">
          <img src={mask} alt="mask" />
        </div>
        <div className="image-container">
          <img src={film} alt="film" style={{ visibility: "hidden" }} />
        </div>
        <div className="image-container">
          <img src={quill} alt="quill" />
        </div>
        <div className="image-container">
          <img src={music} alt="music" style={{ visibility: "hidden" }} />
        </div>
      </div>
    </div>
  );
};

export default Dowload;
